import React from 'react';
import { Link, useParams } from 'react-router-dom';

function SupplierBreadcrumb() {
  const { name } = useParams(); // Get name from the route
  const plantName = name.replace(/-/g, ' ');

  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title mb-2">{plantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/" className="breadcrumb-link">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/suppliers" className="breadcrumb-link">
                Cogeneration Machinery Suppliers in India
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {plantName}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default SupplierBreadcrumb;
